/* WorkFreeli Connect app main entrypoint. */

// Re-export jQuery
// FIXME: Remove this requirement from torture tests.
import $ from 'jquery';

window.$ = window.jQuery = $;

import 'focus-visible';

// We need to setup the jitsi-local-storage as early as possible so that we can start using it.
// NOTE: If jitsi-local-storage is used before the initial setup is performed this will break the use case when we use
// the  local storage from the parent page when the localStorage is disabled. Also the setup is relying that
// window.location is not changed and still has all URL parameters.
import './react/features/base/jitsi-local-storage/setup';
import conference from './conference';
import API from './modules/API';
import UI from './modules/UI/UI';
import translation from './modules/translation/translation';

window.addEventListener('message', handleMessage, false);
function handleMessage(e) {
    // debugger;
    console.log('handleMessage',e.data);    
    if(e.data && e.data.type && e.data.type === 'add_member_group'){
        window.conversation_type = e.data.conversation_type;
        // document.getElementById('add_member_group').style.display = "flex";
    }else if(e.data && e.data.type && e.data.type === 'change_profile_pic'){
        document.getElementById('dominantSpeakerAvatar').src= e.data.img;
        document.getElementById("dominantSpeakerAvatar").style.display = "inline";
    }
    else if(e.data && e.data.type && e.data.type === 'call_link'){
        window.call_link= e.data.call_link;
    }
    else if(e.data && e.data.type && e.data.type === 'watermark_logo'){
        window.watermark_logo= e.data.src;
        document.querySelector('.watermark.leftwatermark').style.backgroundImage = `url(${e.data.src})`;
    }
    else if (e.data && e.data.type && e.data.type === 'watermark_url') {
        window.watermark_url = e.data.url;
        const linkEl = document.querySelector('.watermark.leftwatermark');
        if (linkEl && linkEl.tagName === 'A') {
            linkEl.setAttribute('href', e.data.url);
        }
    }
    else if (e.data && e.data.type && e.data.type === 'app_name') {
        window.app_name = e.data.name;
        
    }
}

window.APP = {
    API,
    conference,
    translation,
    UI
};

// TODO The execution of the mobile app starts from react/index.native.js.
// Similarly, the execution of the Web app should start from react/index.web.js
// for the sake of consistency and ease of understanding. Temporarily though
// because we are at the beginning of introducing React into the Web app, allow
// the execution of the Web app to start from app.js in order to reduce the
// complexity of the beginning step.
import './react';
